import {
  AiInstructionUIFilter,
  ContentSnippetUIFilter,
} from 'src/slices/workflow-preview/types';
import { AiInstruction } from 'src/types/aiInstructionTypes';
import { ContentSnippet } from 'src/types/contentSnippetsTypes';

export const buildLiveOnlyFilters = (aiInstructions: AiInstruction[]) => {
  return aiInstructions
    .filter(instr => instr.is_active && !instr.is_draft)
    .map(instr => ({
      aiInstructionId: instr.ai_instruction_id,
      isDraft: false,
    }));
};

export const buildLiveOnlyContentSnippetFilters = (
  contentSnippets: ContentSnippet[],
) => {
  return contentSnippets
    .filter(snippet => snippet.is_active && !snippet.is_draft)
    .map(snippet => ({
      contentSnippetId: snippet.content_snippet_id,
      isDraft: false,
    }));
};

export const ensureCurrentInstructionInFilters = ({
  aiInstructions,
  currentFilters,
  currentInstructionId,
}: {
  aiInstructions: AiInstruction[];
  currentFilters: AiInstructionUIFilter[];
  currentInstructionId?: string | null;
}): AiInstructionUIFilter[] => {
  if (!currentInstructionId) {
    return currentFilters;
  }
  const hasCurrent = currentFilters.some(
    f => f.aiInstructionId === currentInstructionId,
  );

  if (hasCurrent) {
    return currentFilters.map(f =>
      f.aiInstructionId === currentInstructionId ? { ...f, isDraft: true } : f,
    );
  }
  const current = aiInstructions.find(
    instr => instr.ai_instruction_id === currentInstructionId,
  );
  if (current) {
    return [
      ...currentFilters,
      { aiInstructionId: currentInstructionId, isDraft: true },
    ];
  }
  return currentFilters;
};

export const ensureCurrentContentSnippetInFilters = ({
  contentSnippets,
  currentContentSnippetId,
  currentFilters,
}: {
  contentSnippets: ContentSnippet[];
  currentContentSnippetId?: string | null;
  currentFilters: ContentSnippetUIFilter[];
}): ContentSnippetUIFilter[] => {
  if (!currentContentSnippetId) {
    return currentFilters;
  }
  const hasCurrent = currentFilters.some(
    f => f.contentSnippetId === currentContentSnippetId,
  );

  if (hasCurrent) {
    return currentFilters.map(f =>
      f.contentSnippetId === currentContentSnippetId
        ? { ...f, isDraft: true }
        : f,
    );
  }
  const current = contentSnippets.find(
    snippet => snippet.content_snippet_id === currentContentSnippetId,
  );
  if (current) {
    return [
      ...currentFilters,
      { contentSnippetId: currentContentSnippetId, isDraft: true },
    ];
  }
  return currentFilters;
};
